import Vue from 'vue'
import Vuex from 'vuex'
import CurrentUser from './currentUser'
import SystemSettings from './settings'
import FormInputs from './formInputs'
import MenuState from './menuState'
import AlertState from './alertState'
import AccessDenial from './accessDenial'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    SystemSettings,
    CurrentUser,
    FormInputs,
    MenuState,
    AlertState,
    AccessDenial
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js